// extracted by mini-css-extract-plugin
export default {"position":"MUXrR1Fvrz1DZEVG82Kw"};